module.exports = __webpack_public_path__ + "img/v3-sun.b42fb09b.svg";